import { TAvailableConfigValues } from '@customTypes/common';
import { EBlockingMode } from '@streamLoader/BasePlaylistRotationController/IBasePlaylistRotationController';

export interface IBasePlaylistRotationControllerConfig {
  playlistLoadingTimeout?: number;
  forceStaticPlaylistLoadingTimeout?: boolean;
  staticPlaylistLoadingTimeoutInDurations?: number;
  lowLatencyMode?: boolean;
  equalPlaylistsAmountToDecline?: number;
  blockingMode?: EBlockingMode;
  targetBufferMultiplier: number;
  maxVODPlaylistLoadingRetries?: number;
  maxVODFragmentLoadingRetries?: number;
  baseVODPlaylistRetryTimeout?: number;
  baseVODFragmentRetryTimeout?: number;
  VODLoadNextSegmentThreshold: number;
  disableTimeoutsInVOD: boolean;
  retryLowLatencyPlaylistTimeout: number;
  disableRotateTimeoutIncrease: boolean;
  shouldLogFragmentsHistory: boolean;
  workerMode?: boolean;
  partHoldBack?: number;
  additionalStartParts: number;
  sendCustomRefererHeader: boolean;
}

export const defaultBasePlaylistRotationControllerConfig: IBasePlaylistRotationControllerConfig = {
  playlistLoadingTimeout: 2500,
  forceStaticPlaylistLoadingTimeout: false,
  lowLatencyMode: true,
  equalPlaylistsAmountToDecline: 10,
  blockingMode: EBlockingMode.WAIT_FOR_PLAYLIST,
  maxVODPlaylistLoadingRetries: 3,
  maxVODFragmentLoadingRetries: 3,
  baseVODPlaylistRetryTimeout: 500,
  baseVODFragmentRetryTimeout: 5000,
  VODLoadNextSegmentThreshold: 5000,
  disableTimeoutsInVOD: true,
  retryLowLatencyPlaylistTimeout: 1000,
  targetBufferMultiplier: 1,
  disableRotateTimeoutIncrease: true,
  shouldLogFragmentsHistory: false,
  workerMode: true,
  partHoldBack: undefined,
  additionalStartParts: 2,
  sendCustomRefererHeader: false,
};

export const availableBasePlaylistRotationControllerConfigValues: TAvailableConfigValues<IBasePlaylistRotationControllerConfig> = {
  blockingMode: {
    values: [EBlockingMode.WAIT_FOR_PLAYLIST, EBlockingMode.WAIT_FOR_PREFETCH_SEGMENT],
    isMultiple: false,
  },
};
